import { render } from "./MiddleDesc.vue?vue&type=template&id=3e024a3e&scoped=true"
import script from "./MiddleDesc.vue?vue&type=script&lang=js"
export * from "./MiddleDesc.vue?vue&type=script&lang=js"

import "./MiddleDesc.vue?vue&type=style&index=0&id=3e024a3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e024a3e"]])

export default __exports__